export const getAllVacations = state => [...state.vacations, ...state.addedVacations].reverse();
export const getAllSickLeaves = state => [...state.sickLeaves, ...state.addedSickLeaves].reverse();
export const getAllTimeOff = state => [...state.timeOff, ...state.addedTimeOff].reverse();
export const getAllMedicalLeaves = state => [...state.medicalLeaves, ...state.addedMedicalLeaves].reverse();
export const getAddedMedicalLeaves = state => state.addedMedicalLeaves;
export const getAddedVacations = state => state.addedVacations;
export const getAddedSickLeaves = state => state.addedSickLeaves;
export const getAddedTimeOff = state => state.addedTimeOff;
export const getSelectedMedicalLeaves = state => state.selectedMedicalLeaves;
export const getSelectedVacations = state => state.selectedVacations;
export const getSelectedSickLeaves = state => state.selectedSickLeaves;
export const getSelectedTimeOff = state => state.selectedTimeOff;
export const getHolidays = state => state.holidays;



// WEBPACK FOOTER //
// ./src/store/modules/vacation/getters.js